import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useParams } from "react-router-dom";
import CustomerDetailContent from "./CustomerDetailContent";

const ViewCustomer = () => {
  const { id } = useParams();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <CustomerDetailContent customerId={id} />
    </DashboardLayout>
  );
};

export default ViewCustomer;
